import React, {useEffect, useState} from 'react'
import moment from "moment";
import {message, Pagination, Spin} from "antd"
import parseToken from "../../../helpers/parseToken";
import {formatDate3} from "../../../helpers/formatDate";
import {getUserDataLevel} from "../../../services/api/apiLead";
import ReportHubCustPhoneSearch from "./search/ReportHubCustPhoneSearch";
import {reportHubCustPhoneV2} from "../../../services/api/apiReport2";
import Export from "./actions/Export";
import {searchTenant} from "../../../services/api/apiUser";
import {searchTelco} from "../../../services/api/apiCustomerHub";

const ReportHubCustPhonePage = (props) => {
    const {custId, custName} = props
    const [level, setLevel] = useState(0)
    const [listTelco, setListTelco] = useState([])
    const [showFilter, setShowFilter] = useState(false)
    const [filters, setFilters] = useState({
        fromDate: moment().subtract(3, 'months').startOf('day'),
        toDate: moment().endOf('day'),
        tenantId: custId,
        tenantName: custName,
        telco: "",
        shortPhone: "",
        phoneNumber: "",
        page: "1",
        pagesize: "20"
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [tenants, setTenants] = useState([])
    const [total, setTotal] = useState(0)
    const info = parseToken()

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _onChangeFilters = async (name, value) => {
        let _tenantName = ''
        if (name === 'tenantId' && tenants.length > 0 && filters?.tenantId) {
            const itemTenant = tenants.find(item => item.value + '' === filters.tenantId)
            if (itemTenant !== undefined) {
                _tenantName = itemTenant.label
            }
        }
        await setFilters({
            ...filters,
            [name]: value,
            tenantName: _tenantName,
            page: 1
        })
    }

    const _onChangeDateFrom = (value) => {
        setFilters({
            ...filters,
            fromDate: value,
            page: 1
        })
    }

    const _onChangeDateTo = (value) => {
        setFilters({
            ...filters,
            toDate: value,
            page: 1
        })
    }

    const _fetchListReport = async (levelInit = 0) => {
        setLoading(true)
        setError('')

        try {
            const decodeToken = parseToken()
            const payload = {
                ...filters,
                level: levelInit ? levelInit : level,
                fromDate: formatDate3(filters.fromDate) + ' 00:00:00',
                toDate: formatDate3(filters.toDate) + ' 23:59:00',
                userName: decodeToken.sub,
                pagesize: filters.pagesize + '',
                page: filters.page + ''
            }
            const response = await reportHubCustPhoneV2(payload);
            const {headers, data} = response
            const contentResponse = JSON.parse(headers["content-response"])
            setTotal(contentResponse.data)
            document.getElementById('ReportByConvertedLeadElm').innerHTML = data.replaceAll('file:/u02/ipcc/report/services-report/./../../omap/IPCCMedia/webapps/IPCCMedia/images', import.meta.env.REACT_APP_LINK_SVG_CHART || 'https://103.116.106.115:1770/IPCCMedia/images')

            setLoading(false)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _fetchListTenant = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }
            const response = await searchTenant(payload, info.sub)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _tenants = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.id,
                }
            })

            setTenants([..._tenants])
            if (_tenants.length === 1) {
                setFilters({
                    ...filters,
                    tenantId: _tenants[0].value + ''
                })
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchTelco = async () => {
        try {
            const response = await searchTelco(info.sub)

            const {success, data} = response

            if (parseInt(success) !== 1) {
                return
            }
            const _telcos = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.code,
                }
            })

            setListTelco([..._telcos])
        } catch (e) {
            message.error(e.message)
        }
    }

    const _getUserDataLevel = async () => {
        try {
            const payload = {
                userName: info.sub,
                dataObject: "REPORT",
                dataAction: "VIEW"
            }
            const {data} = await getUserDataLevel(payload)
            const {success, datalevel} = data
            if (parseInt(success) !== 1) {
                return
            }
            await setLevel(datalevel)
            await _fetchListReport(datalevel)
        } catch (e) {

        }
    }

    const _onChangePagination = (page, pageSize) => {
        setFilters({
            ...filters,
            pagesize: pageSize,
            page: pageSize !== filters.pagesize ? 1 : page
        })
    }

    useEffect(() => {
        _getUserDataLevel()
        _fetchListTenant()
        _fetchTelco()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _fetchListReport()
        // eslint-disable-next-line
    }, [filters.fromDate, filters.toDate, filters, filters.page, filters.pagesize])

    return (
        <div className="ReportByDayPage PageDefault">

            <div className="PageHeading">
                <h1 className="PageTitle">Báo cáo đầu số khách hàng theo hướng</h1>
                <div className="PageFilterTop">
                    <div className="FiltersOpen" onClick={_onToggleFilter}>
                        <span className="material-icons Filter">filter_list</span>
                        <label>Bộ lọc</label>
                    </div>
                    <div><Export filters={filters} tenants={tenants} level={level}/></div>
                </div>
            </div>
            {
                showFilter && <div className="Filter">
                    <ReportHubCustPhoneSearch
                        tenants={tenants}
                        listTelco={listTelco}
                        filters={filters}
                        setFilters={setFilters}
                        onChangeFilters={_onChangeFilters}
                        receptionDateFrom={filters.fromDate}
                        receptionDateTo={filters.toDate}
                        onChangeTo={_onChangeDateTo}
                        onChangeFrom={_onChangeDateFrom}
                    />
                </div>
            }
            <Spin spinning={loading} tip="Đang lấy dữ liệu từ server...">
                <div id="ReportByConvertedLeadElm" className="tableReportNormal reportCallFee"></div>
                <div className="PagePagination d-flex justify-content-end align-items-center mt-3">
                    <div className="total mr-3">Total {total} items</div>
                    <Pagination
                        className="PaginationCustom"
                        pageSizeOptions={['20', '50', '100', '200']}
                        total={total}
                        showSizeChanger={true}
                        pageSize={parseInt(filters.pagesize)}
                        current={parseInt(filters.page)}
                        onChange={_onChangePagination}
                    />
                </div>

                {error && <div className="text-danger mt-3">{error}</div>}
            </Spin>
        </div>
    )
}

export default ReportHubCustPhonePage
